var React = require('react');

function UpIconBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.34375 12L0 9.72152L10 0L20 9.72152L17.6562 12L10 4.55696L2.34375 12Z","fill":"#21A4DE"}));
}

UpIconBlue.defaultProps = {"width":"20","height":"12","viewBox":"0 0 20 12","fill":"none"};

module.exports = UpIconBlue;

UpIconBlue.default = UpIconBlue;
